module.exports = {
  mobileMax: 529,
  tabletMin: 530,
  tabletMax: 991,
  desktopMin: 992,
  desktopMax: 1128,
  desktopXlMin: 1129,
};
